var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#005ADC",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "paste-icon-original",
    transform: "translate(9, 10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5714286,13.8571429 L11.7357143,13.8571429 L13.5785714,12.0071429 L12.5714286,11 L9,14.5714286 L12.5714286,18.1428571 L13.5785714,17.1357143 L11.7357143,15.2857143 L17.5714286,15.2857143 L17.5714286,21 L19,21 L19,15.2857143 C19,14.4967361 18.3604068,13.8571429 17.5714286,13.8571429 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7969772,5.94680233 L11.8969853,1.19680795 C11.7648823,1.06978868 11.5860479,0.99897967 11.3999861,1.00001111 L4.39999768,1.00001111 C3.62680031,1.00001111 3,1.6076353 3,2.35716372 L3,18.6428587 C3,19.3923872 3.62680031,20 4.39999768,20 L9.99998841,20 L9.99998841,18.6428587 L4.39999768,18.6428587 L4.39999768,2.35716372 L9.99998841,2.35716372 L9.99998841,6.42858748 C9.99998841,7.17811589 10.6267887,7.78572873 11.3999861,7.78572873 L15.5999791,7.78572873 L15.5999791,9.14286998 L16.9999885,9.14286998 L16.9999885,6.42858748 C17.0010526,6.24822138 16.9280075,6.07486139 16.7969772,5.94680233 Z M11.3999861,2.63537768 L15.3129796,6.42858748 L11.3999861,6.42858748 L11.3999861,2.63537768 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/paste.6c07339f5dd7cc6005a39ab8d4d8d189.svg";
export { ForwardRef as ReactComponent };